import { useCallback, useContext } from 'react'
import UserContext from '../contexts/user'
import { IUser } from '../apilibrary/types/user'

type UseSetCurrentUserReturn = (user?: IUser) => void

const useSetCurrentUser = (): UseSetCurrentUserReturn => {
  const { setUser } = useContext(UserContext)

  return useCallback(
    (user?: IUser) => {
      setUser(user)
    },
    [setUser]
  )
}

export default useSetCurrentUser;
